import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/comparables';

const namespace = 'ANALYSIS';

export const UPDATE_EQUITY_TIER_SELECTION_ORDER = createRequestTypes(
  `${namespace}/UPDATE_EQUITY_TIER_SELECTION_ORDER`,
);

export const updateEquityTierSelectionOrder = makeApiActionCreatorV3(
  api.updateEquityTierSelectionOrder,
  UPDATE_EQUITY_TIER_SELECTION_ORDER[START],
  UPDATE_EQUITY_TIER_SELECTION_ORDER[SUCCESS],
  UPDATE_EQUITY_TIER_SELECTION_ORDER[ERROR],
);

export const UPDATE_SALES_TIER_SELECTION_ORDER = createRequestTypes(
  `${namespace}/UPDATE_SALES_TIER_SELECTION_ORDER`,
);

export const updateSalesTierSelectionOrder = makeApiActionCreatorV3(
  api.updateSalesTierSelectionOrder,
  UPDATE_SALES_TIER_SELECTION_ORDER[START],
  UPDATE_SALES_TIER_SELECTION_ORDER[SUCCESS],
  UPDATE_SALES_TIER_SELECTION_ORDER[ERROR],
);

export const FETCH_EQUITY_TIER_SELECTION_ALL = createRequestTypes(
  `${namespace}/FETCH_EQUITY_TIER_SELECTION_ALL`,
);

export const fetchEquityTierSelectionAll = makeApiActionCreatorV3(
  api.fetchEquityTierSelectionAll,
  FETCH_EQUITY_TIER_SELECTION_ALL[START],
  FETCH_EQUITY_TIER_SELECTION_ALL[SUCCESS],
  FETCH_EQUITY_TIER_SELECTION_ALL[ERROR],
);

export const INSERT_EQUITY_TIER_SELECTION = createRequestTypes(
  `${namespace}/INSERT_EQUITY_TIER_SELECTION`,
);

export const insertEquityTierSelection = makeApiActionCreatorV3(
  api.insertEquityTierSelection,
  INSERT_EQUITY_TIER_SELECTION[START],
  INSERT_EQUITY_TIER_SELECTION[SUCCESS],
  INSERT_EQUITY_TIER_SELECTION[ERROR],
);

export const UPDATE_EQUITY_TIER_SELECTION = createRequestTypes(
  `${namespace}/UPDATE_EQUITY_TIER_SELECTION`,
);

export const updateEquityTierSelection = makeApiActionCreatorV3(
  api.updateEquityTierSelection,
  UPDATE_EQUITY_TIER_SELECTION[START],
  UPDATE_EQUITY_TIER_SELECTION[SUCCESS],
  UPDATE_EQUITY_TIER_SELECTION[ERROR],
);

export const DELETE_EQUITY_TIER_SELECTION = createRequestTypes(
  `${namespace}/DELETE_EQUITY_TIER_SELECTION`,
);

export const deleteEquityTierSelection = makeApiActionCreatorV3(
  api.deleteEquityTierSelection,
  DELETE_EQUITY_TIER_SELECTION[START],
  DELETE_EQUITY_TIER_SELECTION[SUCCESS],
  DELETE_EQUITY_TIER_SELECTION[ERROR],
);

export const INSERT_CONFIG_SCORING_RULE = createRequestTypes(
  `${namespace}/INSERT_CONFIG_SCORING_RULE`,
);

export const insertConfigScoringRule = makeApiActionCreatorV3(
  api.insertConfigScoringRule,
  INSERT_CONFIG_SCORING_RULE[START],
  INSERT_CONFIG_SCORING_RULE[SUCCESS],
  INSERT_CONFIG_SCORING_RULE[ERROR],
);

export const UPDATE_CONFIG_SCORING_RULE = createRequestTypes(
  `${namespace}/UPDATE_CONFIG_SCORING_RULE`,
);

export const updateConfigScoringRule = makeApiActionCreatorV3(
  api.updateConfigScoringRule,
  UPDATE_CONFIG_SCORING_RULE[START],
  UPDATE_CONFIG_SCORING_RULE[SUCCESS],
  UPDATE_CONFIG_SCORING_RULE[ERROR],
);

export const DELETE_CONFIG_SCORING_RULE = createRequestTypes(
  `${namespace}/DELETE_CONFIG_SCORING_RULE`,
);

export const deleteConfigScoringRule = makeApiActionCreatorV3(
  api.deleteConfigScoringRule,
  DELETE_CONFIG_SCORING_RULE[START],
  DELETE_CONFIG_SCORING_RULE[SUCCESS],
  DELETE_CONFIG_SCORING_RULE[ERROR],
);

export const FETCH_EQUITY_CONFIG_ALL = createRequestTypes(
  `${namespace}/FETCH_EQUITY_CONFIG_ALL`,
);

export const fetchEquityConfigAll = makeApiActionCreatorV3(
  api.fetchEquityConfigAll,
  FETCH_EQUITY_CONFIG_ALL[START],
  FETCH_EQUITY_CONFIG_ALL[SUCCESS],
  FETCH_EQUITY_CONFIG_ALL[ERROR],
);

export const UPDATE_EQUITY_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_EQUITY_CONFIG`,
);

export const updateEquityConfig = makeApiActionCreatorV3(
  api.updateEquityConfig,
  UPDATE_EQUITY_CONFIG[START],
  UPDATE_EQUITY_CONFIG[SUCCESS],
  UPDATE_EQUITY_CONFIG[ERROR],
);

export const INSERT_EQUITY_CONFIG = createRequestTypes(
  `${namespace}/INSERT_EQUITY_CONFIG`,
);

export const insertEquityConfig = makeApiActionCreatorV3(
  api.insertEquityConfig,
  INSERT_EQUITY_CONFIG[START],
  INSERT_EQUITY_CONFIG[SUCCESS],
  INSERT_EQUITY_CONFIG[ERROR],
);

export const FETCH_CONFIG_SCORING_RULES_ALL = createRequestTypes(
  `${namespace}/FETCH_CONFIG_SCORING_RULES_ALL`,
);

export const fetchConfigScoringRulesAll = makeApiActionCreatorV3(
  api.fetchConfigScoringRulesAll,
  FETCH_CONFIG_SCORING_RULES_ALL[START],
  FETCH_CONFIG_SCORING_RULES_ALL[SUCCESS],
  FETCH_CONFIG_SCORING_RULES_ALL[ERROR],
);

export const FETCH_EQUITY_SCORING_FIELDS = createRequestTypes(
  `${namespace}/FETCH_EQUITY_SCORING_FIELDS`,
);

export const fetchEquityScoringFields = makeApiActionCreatorV3(
  api.fetchEquityScoringFields,
  FETCH_EQUITY_SCORING_FIELDS[START],
  FETCH_EQUITY_SCORING_FIELDS[SUCCESS],
  FETCH_EQUITY_SCORING_FIELDS[ERROR],
);

export const FETCH_SALES_TIER_SELECTION_ALL = createRequestTypes(
  `${namespace}/FETCH_SALES_TIER_SELECTION_ALL`,
);

export const fetchSalesTierSelectionAll = makeApiActionCreatorV3(
  api.fetchSalesTierSelectionAll,
  FETCH_SALES_TIER_SELECTION_ALL[START],
  FETCH_SALES_TIER_SELECTION_ALL[SUCCESS],
  FETCH_SALES_TIER_SELECTION_ALL[ERROR],
);

export const INSERT_SALES_TIER_SELECTION = createRequestTypes(
  `${namespace}/INSERT_SALES_TIER_SELECTION`,
);

export const insertSalesTierSelection = makeApiActionCreatorV3(
  api.insertSalesTierSelection,
  INSERT_SALES_TIER_SELECTION[START],
  INSERT_SALES_TIER_SELECTION[SUCCESS],
  INSERT_SALES_TIER_SELECTION[ERROR],
);

export const UPDATE_SALES_TIER_SELECTION = createRequestTypes(
  `${namespace}/UPDATE_SALES_TIER_SELECTION`,
);

export const updateSalesTierSelection = makeApiActionCreatorV3(
  api.updateSalesTierSelection,
  UPDATE_SALES_TIER_SELECTION[START],
  UPDATE_SALES_TIER_SELECTION[SUCCESS],
  UPDATE_SALES_TIER_SELECTION[ERROR],
);

export const DELETE_SALES_TIER_SELECTION = createRequestTypes(
  `${namespace}/DELETE_SALES_TIER_SELECTION`,
);

export const deleteSalesTierSelection = makeApiActionCreatorV3(
  api.deleteSalesTierSelection,
  DELETE_SALES_TIER_SELECTION[START],
  DELETE_SALES_TIER_SELECTION[SUCCESS],
  DELETE_SALES_TIER_SELECTION[ERROR],
);

export const INSERT_SALES_CONFIG_SCORING_RULE = createRequestTypes(
  `${namespace}/INSERT_SALES_CONFIG_SCORING_RULE`,
);

export const insertSalesConfigScoringRule = makeApiActionCreatorV3(
  api.insertSalesConfigScoringRule,
  INSERT_SALES_CONFIG_SCORING_RULE[START],
  INSERT_SALES_CONFIG_SCORING_RULE[SUCCESS],
  INSERT_SALES_CONFIG_SCORING_RULE[ERROR],
);

export const UPDATE_SALES_CONFIG_SCORING_RULE = createRequestTypes(
  `${namespace}/UPDATE_SALES_CONFIG_SCORING_RULE`,
);

export const updateSalesConfigScoringRule = makeApiActionCreatorV3(
  api.updateSalesConfigScoringRule,
  UPDATE_SALES_CONFIG_SCORING_RULE[START],
  UPDATE_SALES_CONFIG_SCORING_RULE[SUCCESS],
  UPDATE_SALES_CONFIG_SCORING_RULE[ERROR],
);

export const DELETE_SALES_CONFIG_SCORING_RULE = createRequestTypes(
  `${namespace}/DELETE_SALES_CONFIG_SCORING_RULE`,
);

export const deleteSalesConfigScoringRule = makeApiActionCreatorV3(
  api.deleteSalesConfigScoringRule,
  DELETE_SALES_CONFIG_SCORING_RULE[START],
  DELETE_SALES_CONFIG_SCORING_RULE[SUCCESS],
  DELETE_SALES_CONFIG_SCORING_RULE[ERROR],
);

export const FETCH_SALES_CONFIG_ALL = createRequestTypes(
  `${namespace}/FETCH_SALES_CONFIG_ALL`,
);

export const fetchSalesConfigAll = makeApiActionCreatorV3(
  api.fetchSalesConfigAll,
  FETCH_SALES_CONFIG_ALL[START],
  FETCH_SALES_CONFIG_ALL[SUCCESS],
  FETCH_SALES_CONFIG_ALL[ERROR],
);

export const UPDATE_SALES_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_SALES_CONFIG`,
);

export const updateSalesConfig = makeApiActionCreatorV3(
  api.updateSalesConfig,
  UPDATE_SALES_CONFIG[START],
  UPDATE_SALES_CONFIG[SUCCESS],
  UPDATE_SALES_CONFIG[ERROR],
);

export const INSERT_SALES_CONFIG = createRequestTypes(
  `${namespace}/INSERT_SALES_CONFIG`,
);

export const insertSalesConfig = makeApiActionCreatorV3(
  api.insertSalesConfig,
  INSERT_SALES_CONFIG[START],
  INSERT_SALES_CONFIG[SUCCESS],
  INSERT_SALES_CONFIG[ERROR],
);

export const FETCH_SALES_CONFIG_SCORING_RULES_ALL = createRequestTypes(
  `${namespace}/FETCH_SALES_CONFIG_SCORING_RULES_ALL`,
);

export const fetchSalesConfigScoringRulesAll = makeApiActionCreatorV3(
  api.fetchSalesConfigScoringRulesAll,
  FETCH_SALES_CONFIG_SCORING_RULES_ALL[START],
  FETCH_SALES_CONFIG_SCORING_RULES_ALL[SUCCESS],
  FETCH_SALES_CONFIG_SCORING_RULES_ALL[ERROR],
);

export const FETCH_SALES_SCORING_FIELDS = createRequestTypes(
  `${namespace}/FETCH_SALES_SCORING_FIELDS`,
);

export const fetchSalesScoringFields = makeApiActionCreatorV3(
  api.fetchSalesScoringFields,
  FETCH_SALES_SCORING_FIELDS[START],
  FETCH_SALES_SCORING_FIELDS[SUCCESS],
  FETCH_SALES_SCORING_FIELDS[ERROR],
);

export const FETCH_DROPDOWNS = createRequestTypes(
  `${namespace}/FETCH_DROPDOWNS`,
);

export const fetchDropdowns = makeApiActionCreatorV3(
  api.getDropdownValues,
  FETCH_DROPDOWNS[START],
  FETCH_DROPDOWNS[SUCCESS],
  FETCH_DROPDOWNS[ERROR],
);
